<style lang="less">
.l-parser-item{
    background:#00000011;
    margin:5px;
    padding:5px;
    border-radius:5px;
}

.l-parser-item:hover{
    background:#33669911;
    cursor:pointer;
    transition: all 0.5s;
}
</style>
<template>
  <Dropdown trigger="custom" :visible="showDropdown" @on-clickoutside="showDropdown=false">
    <Button @click="showDropdown = !showDropdown" type="primary">提示词({{ items.length }})</Button>
    <Button @click="save">保存提示词</Button>
    <DropdownMenu slot="list" style="width:500px;padding:0px 5px;">
        <div><Input v-model="search" placeholder="搜索" /></div>
        <div style="max-height:500px;overflow-y:auto">
            <div v-for="item in filteredItems">
                <div @click="select(item)" :key="item.id" class="l-parser-item">
                    <div class="flex-wrap flex-between">{{ item.name }}
                        <BaseNameBoard :size="15" :uid="item.created_by" />

                    </div>
                    <div style="color:var(--subtext2)">{{ item.content.slice(0,30) }}...</div></div>
            </div>
        </div>

    </DropdownMenu>

    <Modal v-model="showEditor" title="编辑提示词" footer-hide>
        <Form>
            <FormItem label="提示词标题">
                <Input placeholder="为你的提示词取一个名字吧" v-model="formData.name"></Input>
            </FormItem>
            <FormItem label="提示词标题">
                <Input type="textarea" v-model="formData.content" :rows=4 placeholder="提示词内容"></Input>
            </FormItem>
            <div class="flex-wrap flex-center split5">
                <Button type="primary" @click="submitSave">提交</Button>
                <Button @click="showEditor=false">取消 </Button>
            </div>
        </Form>
    </Modal>
  </Dropdown>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      showDropdown: false,
      items: [],
      search:'',
      showEditor:false,
      formData: {},
    };
  },
  computed: {
    filteredItems() {
      if (this.search) {
        return this.items;
      } else {
        return this.items;
      }
    },
    user_id() {
      return this.$store.getters['session/sesion'].id;
    },
  },
  mounted() {
    this.$api.afterLogin(()=>{
      
      this.getData();
    })
  },
  methods: {
    getData() {
      this.$api.get('ai/parse').then((res)=>{
        this.items = res.data.data;
      });
    },
    select(item) {
      this.$emit('input', item.content);
      this.showDropdown = false;
    },
    save() {
      this.formData = {
        name: null,
        content: this.value,
      };
      this.showEditor = true;
    },
    submitSave() {
      if (!this.formData.name || !this.formData.content) {
        this.Error('标题和内容不可为空');
        return;
      }
      this.$api.post('ai/parse', this.formData).then((res)=>{
        this.Success('提交成功');
        this.showEditor = false;
        this.formData = {};
        this.getData();
      }).catch((e)=>{
        this.Error(e);
      });
    },
  },
};
</script>

<style>

</style>
